


































































import _ from 'lodash';
import Vue from 'vue';
import Component, {mixins} from 'vue-class-component';
import {State} from 'vuex-class';
import {PrologueTheme} from '@/themes';
// import { VuetifyTheme } from 'vuetify'
import {InputStyle} from '@/store/types';
import StyleMixin from '@/modules/core/style/StyleMixin';

@Component
export default class ThemeSelector extends mixins(StyleMixin) {
    @State(state => state.themeSelector)
    public themeSelector: boolean;

    @State(state => state.themes)
    public themes: PrologueTheme[];

    public navigationOptions = [
        { text: 'Permanente', value: 'permanent'},
        // { text: 'Oculta', value: 'hiddem'},
        // { text: 'Minificada (Abrir al hacer click)', value: 'minify-click'},
        { text: 'Minificada (Abrir al pasar)', value: 'minify-hover'},
    ]

    public get navigationMode () {
        return this.$store.state.navigationMode
    }

    public set navigationMode (mode: string) {
        localStorage.setItem('config.navigationMode', mode)
        this.$store.commit('setNavigationMode', mode)
    }

    public get inputStyles (): string[] {
        return _.values(InputStyle);
    }

    public getDeclaredColors (theme: Partial<any>) {
        const colors = ['primary', 'accent', 'secondary', 'info', 'warning', 'error', 'success'];
        const declaredColors = _.intersection(Object.keys(theme), colors);

        return declaredColors;
    }

    public changeInputStyle (style: InputStyle) {
        localStorage.setItem('config.inputStyle', style);
        this.$store.commit('setInputStyle', style);
    }

    public changeTheme (theme: PrologueTheme) {
        localStorage.setItem('config.theme', theme.key);
        this.$store.commit('setCurrentTheme', theme);
    }

    public get darkMode (): boolean {
        return this.$store.state.darkMode;
    }

    public set darkMode (darkMode: boolean) {
        this.$store.commit('toggleDarkMode', darkMode);
    }

    public get permanentNavigation (): boolean {
        return this.$store.state.permanentNavigation;
    }

    public set permanentNavigation (value: boolean) {
        localStorage.setItem('config.permanentNavigation', value ? 'true' : 'false');
        if (!value) {
            this.$store.commit('toggleDisplayTemporalNavigation', false);
        }

        this.$store.commit('togglePermanentNavigation', value);
    }

    public get isMobile (): boolean {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    }
}
